"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_COLUMN_COUNT = exports.ITEM_GAP = exports.ITEM_MAX_WIDTH = exports.ITEM_WIDTH = void 0;
exports.ITEM_WIDTH = 230;
exports.ITEM_MAX_WIDTH = 350;
exports.ITEM_GAP = 8;
exports.DEFAULT_COLUMN_COUNT = 1;
